import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { FuseFullscreenModule } from "@fuse/components/fullscreen";
import { FuseNavigationModule } from "@fuse/components/navigation";
import { MessagesModule } from "app/layout/common/messages/messages.module";
import { NotificationsModule } from "app/layout/common/notifications/notifications.module";
import { SearchModule } from "app/layout/common/search/search.module";
import { ShortcutsModule } from "app/layout/common/shortcuts/shortcuts.module";
import { UserMenuModule } from "app/layout/common/user-menu/user-menu.module";
import { SharedModule } from "app/shared/shared.module";
import { ModernLayoutComponent } from "app/layout/layouts/horizontal/modern/modern.component";
import { MatFormField, MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatInputModule } from "@angular/material/input";
import { MatRippleModule } from "@angular/material/core";
import { SettingsModule } from "app/layout/common/settings/settings.module";
import { ProjectStarterModule } from "app/layout/common/project-starter/project-starter.module";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { SharedModule as SharedComponentsModule } from "../../../../components/shared/shared.module";

@NgModule({
    declarations: [ModernLayoutComponent],
    imports: [
        HttpClientModule,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatRippleModule,
        FuseFullscreenModule,
        FuseNavigationModule,
        MessagesModule,
        NotificationsModule,
        SearchModule,
        ShortcutsModule,
        UserMenuModule,
        SettingsModule,
        ProjectStarterModule,
        SharedModule,
        MatSlideToggleModule,
        SharedComponentsModule,
    ],
    exports: [ModernLayoutComponent],
})
export class ModernLayoutModule {}
